export const PAYMENT_UPDATE = 'PAYMENT_UPDATE';
export const PAYMENT_UPDATE_DONE = 'PAYMENT_UPDATE_DONE';
export const PAYMENT_UPDATE_ERROR = 'PAYMENT_UPDATE_ERROR';
export const PAYMENT_UPDATE_RESET = 'PAYMENT_UPDATE_RESET';
//# sourceMappingURL=actionTypes.js.map